import { render, staticRenderFns } from "./ViewingRooms.vue?vue&type=template&id=32d37d3d&scoped=true"
import script from "./ViewingRooms.vue?vue&type=script&lang=js"
export * from "./ViewingRooms.vue?vue&type=script&lang=js"
import style0 from "./ViewingRooms.vue?vue&type=style&index=0&id=32d37d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d37d3d",
  null
  
)

export default component.exports